

function PlTitle(props)
{

    var nazwaPlacowki = "";


    if(props.userData.pl != undefined)
    {
        for(var px =0; px<props.userData.pl.length; px++)
            {
                if(props.userData.pl[px].id  == props.userData.p_przedszkole_id )
                {
                    nazwaPlacowki = props.userData.pl[px].nazwa;
                }
            }
    }
  

    return <span>{nazwaPlacowki}   </span>
}


export default PlTitle;